<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0" cols="12">
        <span class="text-uppercase page-subtitle d-block">Templates</span>
        <h3 class="page-title d-inline">{{ template.id ? 'Editar' : 'Novo' }}</h3>
        <router-link class="btn btn-success text-white float-right" v-if="template.id" :to="{ name: 'admin-quotation-template-new' }">Novo template</router-link>
        <d-button type="button" @click.prevent="save" class="btn-accent float-right mr-2">Salvar</d-button>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <d-card class="card-small mb-4">
          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <d-row class="align-items-center">
              <d-col cols="12" lg="4">
                <h6 class="m-0">Dados cadastrais</h6>
              </d-col>
            </d-row>
          </d-card-header>

          <template-form :template="template" ref="templateForm"/>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import TemplateForm from '_modules/quotation/components/TemplateForm.vue';
import QuotationButtons from '_modules/quotation/components/QuotationButtons.vue';
import QuotationService from '_services/rest/modules/quotation';
import { TEMPLATE_MODEL, _LOAD_TEMPLATE_MODEL_ } from '_modules/quotation/components/QuotationModel';

export default {
  name: 'quotation-template-edit',
  components: {
    TemplateForm,
    QuotationButtons,
  },
  data() {
    return {
      template: cloneDeep(TEMPLATE_MODEL),
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getTemplate',
    ]),
    getQuotationTemplate() {
      this.setToggle({ type: 'progress', bool: true });
      this.getTemplate(parseInt(this.$route.params.templateId, Number))
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    save() {
      this.$refs.templateForm.save();
    },
  },
  mounted() {
    if (this.$route.params.templateId) {
      QuotationService.getTemplateById(this.$route.params.templateId)
        .then(response => {
          this.template = response;
          Events.$emit(_LOAD_TEMPLATE_MODEL_, response);
        });
    }
  },
};
</script>
